import React from 'react';
import { Zap, Cpu, Globe } from 'lucide-react';
import { RevealSection, RevealCard } from '../Animations';

const WhyEmerge = () => {
  const advantages = [
    {
      title: 'Rapid Deployment',
      description:
        "We don't do 'months-long' projects. Your first AI voice agent or n8n workflow can be live and saving you time in under 14 days. We focus on speed to value.",
      icon: Zap,
    },
    {
      title: 'Expert Builders',
      description:
        "We aren't just consultants who give advice and leave. We're technical builders who connect your software, train your models, and ensure your systems are bulletproof.",
      icon: Cpu,
    },
    {
      title: 'Global Reach',
      description:
        "Operating across the UK and USA, we provide 24/7 monitoring and support. Whether you're in London or New York, our team is always available to help you scale.",
      icon: Globe,
    },
  ];

  return (
    <section id="why-us" className="section-padding relative overflow-hidden">
      <div className="container-custom">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12 md:mb-16">
          <RevealSection className="lg:col-span-7">
            <span className="eyebrow">03. Why us</span>
            <div className="mt-3 mb-8 h-px bg-white/10" />
            <h2 className="text-[clamp(2rem,4.5vw,3.5rem)] font-display font-semibold text-white leading-[1.05] tracking-[-0.03em]">
              The Emerge advantage
            </h2>
          </RevealSection>
          <RevealSection className="lg:col-span-5">
            <p className="text-[17px] text-zinc-400 leading-[1.65] max-w-xl">
              Why business owners choose a specialized AI agency over traditional consulting. We don't just talk about AI. We build the systems that help your business scale.
            </p>
          </RevealSection>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5">
          {advantages.map((adv) => (
            <RevealCard
              key={adv.title}
              className="p-8 rounded-[var(--radius-lg)] bg-[color:var(--color-surface-1)] border border-white/10 hover:border-white/25 transition-colors"
            >
              <div className="w-10 h-10 rounded-[var(--radius-sm)] border border-white/10 bg-white/[0.02] flex items-center justify-center mb-6">
                <adv.icon className="w-5 h-5 text-[color:var(--color-accent)]" strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-semibold text-white mb-3 tracking-[-0.01em]">
                {adv.title}
              </h3>
              <p className="text-[15px] text-zinc-400 leading-relaxed">{adv.description}</p>
            </RevealCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyEmerge;
